import React, { PureComponent } from 'react';
import Header from './AuthHeader';

class Layout extends PureComponent {
  render() {
    return (
      <div className="tm-page">
        <div className="uk-section-default uk-section">
          <Header />
        </div>
        <div className="uk-section-default uk-section uk-section-xsmall">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Layout;
